<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="wrap">
        <div class="my-user-qna-info">
          <span class="cs-number">1599-3709</span>
          <ul class="cs-meta-list">
            <li>평일 09:00-18:00 *점심시간 12:00-13:00</li>
            <li>주말 및 공휴일 휴무</li>
          </ul>
          <p>wavve 서비스 이용 시 불편사항이나 문의사항을 1:1 문의로 보내주시면<br>신속하고 친절하게 안내해 드리겠습니다!</p>
          <a href="https://member.wavve.com/customer/qna/ask" class="link-inquiry">1:1 문의하기</a>
        </div>
      </div>
    </section>
    <section v-if="hasLogin">
      <div class="mypooq-info-body">
        <div class="wrap">
          <div class="my-qa-wrap">
            <h3 class="my-qa-tit">나의 문의 내역</h3>
            <table v-if="qnaList && qnaList.length !== 0" class="my-qa-table">
              <caption class="blind">1:1문의</caption>
              <colgroup>
                <col style="width: 140px;">
                <col style="width: 140px;">
                <col>
                <col style="width: 140px;">
              </colgroup>
              <thead>
              <tr>
                <th>상태</th>
                <th>구분</th>
                <th><p class="al">제목</p></th>
                <th>등록일</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="(qna, index) in qnaList" :key="index" :for="index">
                <td>{{ qna.status }}</td>
                <td>{{ qna.questiontype }}</td>
                <td><p class="al" @click="goQnaView(qna.qnaid)">{{ qna.title }}</p></td>
                <td>{{ qna.regdate }}</td>
              </tr>
              </tbody>
            </table>

            <div v-if="qnaList && qnaList.length === 0" class="my-qa-empty">
              <empty-list text="문의 내역이 없어요."></empty-list>
            </div>

          </div>

          <!-- 페이징 -->
          <paging-component v-if="qnaList && qnaList.length !== 0"
                            :current-page="currentPage"
                            :page-count="pageCount"
                            :limit="limit"
                            :paging-count="10"
                            wrapper-class="paging-type02"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash'
import PagingComponent from '@/components/common/PagingComponent'
import { getUserQna } from '@/common/utils/request'
import queryString from '@/common/utils/querystring'
import EmptyList from '@/components/mypooq/EmptyList'
import cookie from '@/common/utils/cookie'
export default {
  components: {
    PagingComponent,
    EmptyList
  },
  data () {
    return {
      qnaList: [],
      currentPage: +queryString.getQueryParamValue(this.$route, 'page', '1'),
      limit: 15,
      pageCount: 0,
      hasLogin: cookie.getCredential() !== 'none'
    }
  },
  methods: {
    goQnaView (qnaid) {
      this.$router.push({
        name: 'user_qna_view',
        query: {
          qnaid: qnaid
        }
      })
    },
    setData () {
      if (!this.hasLogin) return
      let offset = this.limit * (this.currentPage - 1)

      getUserQna({ offset, limit: this.limit, orderby: 'new' }).then(({ data }) => {
        this.qnaList = _.get(data, 'list', [])
        this.pageCount = Number(_.get(data, 'pagecount', '0'))
      })
    }
  },
  created () {
    console.log('test')
    this.setData()
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
<style lang="css" src="@/assets/css/mypooq.css"></style>
